<template>
    <v-tabs
        :value="activeTab"
        background-color="transparent"
        class="denser-tabs"
        slider-size="4"
        @change="$emit('change', $event)"
    >
        <v-tab
            v-for="(tab, index) in noteTopics"
            :key="index"
        >
            <span class="caption font-weight-medium">
                {{ tab.text }}
            </span>
        </v-tab>
    </v-tabs>
</template>

<script>
export default {
    name: "NoteTabs",
    props: {
        activeTab: {
            type: Number,
            required: true
        },
        noteTopics: {
            type: Array,
            required: true
        }
    }
};
</script>
